import React, { useState, useEffect } from 'react';

// material-ui
import {
  Button,
  FormHelperText,
  Grid,
  InputLabel,
  OutlinedInput,
  Stack,
  Snackbar ,
  IconButton ,
  Link,
  InputAdornment,
  } from '@mui/material';
  import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// third party
import * as Yup from 'yup';
import { Formik } from 'formik';

import AnimateButton from 'components/@extended/AnimateButton';

import axios from 'axios.js';
import { CloseOutlined  } from '@ant-design/icons';

const RESEND_OTP_SECONDS = 30; // cooldown duration

const AuthChangePassword = (props) => {
    const IsLoginLinkHide=props.IsLoginLinkHide
    const navigate = useNavigate();
    //const [MobileNumber,setMobileNumber]=useState("")
    const [open, setOpen] = useState(false);
    const [successMessage, setsuccessMessage] = useState("")
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpen(false);
      };

      const [showPassword, setShowPassword] = useState(false);
      const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
        };
      const [showConfirmPassword, setShowConfirmPassword] = useState(false);
      const handleClickShowConfirmPassword = () => {
        setShowConfirmPassword(!showConfirmPassword);
        };

    const handleMouseDownPassword = (event) => {
      event.preventDefault();
    };
    const handleMouseDownConfirmPassword = (event) => {
        event.preventDefault();
      };

    // ---- Resend OTP state ----
    const [resendLoading, setResendLoading] = useState(false);
    const [resendTimer, setResendTimer] = useState(0); // seconds remaining

    useEffect(() => {
        if (resendTimer <= 0) return;
        const interval = setInterval(() => {
            setResendTimer((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);
        return () => clearInterval(interval);
    }, [resendTimer]);

    const handleResendOTP = async () => {
        if (resendTimer > 0 || resendLoading) return;

        setResendLoading(true);
        try {
            const response = await axios.post('/resend-otp', {
                MobileNumber: localStorage.getItem('MobileNumber')
            });

            if (response.data.Status === 0) {
                setsuccessMessage(response.data.Message || 'Failed to resend OTP');
            } else {
                setsuccessMessage(response.data.Message || 'OTP sent successfully');
                setResendTimer(RESEND_OTP_SECONDS);
            }
            setOpen(true);
        } catch (err) {
            setsuccessMessage(err.message || 'Something went wrong while resending OTP');
            setOpen(true);
        } finally {
            setResendLoading(false);
        }
    };

    const action = (
        <React.Fragment>

          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseOutlined fontSize="small" />
          </IconButton>
        </React.Fragment>
      );

  return (
    <>
      <Formik
        initialValues={{
          OTP: '',
          password:'',
          confirmpassword:'',
          submit: null
        }}
        validationSchema={Yup.object().shape({
            OTP: Yup.number().required("Enter valid OTP"),
            password: Yup.string().required("Enter Password"),
            // FIX: password-match check used to live only inside onSubmit
            // (as a manual `if` that called setErrors but never
            // setSubmitting(false) on the early return) - that left the
            // Change Password button permanently disabled after a
            // mismatch. Moving it into the schema gives real-time
            // validation like the other fields, and Formik handles the
            // submitting state correctly since onSubmit is simply never
            // called until this passes.
            confirmpassword: Yup.string()
                .required("Enter Confirm Password")
                .oneOf([Yup.ref('password'), null], 'Passwords do not match'),
        })}
        onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
            try
            {
                if(values.OTP==="")
                {
                    setErrors({ OTP: "Enter valid OTP" });
                    setSubmitting(false);
                    return false;
                }
                //setMobileNumber(localStorage.getItem('MobileNumber'))
                await axios.post('/do-change-password', {
                    OTP:values.OTP,
                    MobileNumber:localStorage.getItem('MobileNumber'),
                    Password:values.password
                }).then((response) => {
                    if(response.data.Status===0)
                    {
                        setStatus({ success: false });
                        setErrors({ submit: response.data.Message });
                        setSubmitting(false);
                    }
                    else
                    {
                        setStatus({ success: true });
                        setsuccessMessage(response.data.Message)
                        setOpen(true);
                        localStorage.removeItem("MobileNumber")
                        // redirect to login after password successfully changed
                        setTimeout(() => {
                             navigate('/login', { replace: true });
                         }, 2000)
                    }
                });

            setStatus({ success: false });
            setSubmitting(false);
          } catch (err) {
            setStatus({ success: false });
            setErrors({ submit: err.message });
            setSubmitting(false);
          }
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
          <form noValidate onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Stack spacing={1}>
                  <InputLabel htmlFor="OTP">Enter OTP </InputLabel>
                  <OutlinedInput
                    id="OTP"
                    type="text"
                    value={values.OTP}
                    name="OTP"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    placeholder="Enter OTP"
                    fullWidth
                    error={Boolean(touched.OTP && errors.OTP)}
                  />
                  {touched.OTP && errors.OTP && (
                    <FormHelperText error id="standard-weight-helper-text-email-login">
                      {errors.OTP}
                    </FormHelperText>
                  )}

                  {/* Resend OTP link */}
                  <Stack direction="row" justifyContent="flex-end">
                    <Link
                      component="button"
                      type="button"
                      variant="body2"
                      underline="hover"
                      onClick={handleResendOTP}
                      disabled={resendTimer > 0 || resendLoading}
                      sx={{
                        cursor: (resendTimer > 0 || resendLoading) ? 'not-allowed' : 'pointer',
                        color: (resendTimer > 0 || resendLoading) ? 'text.disabled' : 'primary.main'
                      }}
                    >
                      {resendLoading
                        ? 'Sending...'
                        : resendTimer > 0
                          ? `Resend OTP in ${resendTimer}s`
                          : 'Resend OTP'}
                    </Link>
                  </Stack>
                </Stack>
              </Grid>

              <Grid item xs={12}>
                <Stack spacing={1}>
                  <InputLabel htmlFor="password-login">Password</InputLabel>
                  <OutlinedInput
                    fullWidth
                    error={Boolean(touched.password && errors.password)}
                    id="password-login"
                    type={showPassword ? 'text' : 'password'}
                    value={values.password}
                    name="password"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                          size="large"
                        >
                          {showPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                        </IconButton>
                      </InputAdornment>
                    }
                    placeholder="Enter Password"
                  />
                  {touched.password && errors.password && (
                    <FormHelperText error id="standard-weight-helper-text-password-login">
                      {errors.password}
                    </FormHelperText>
                  )}
                </Stack>
              </Grid>

              <Grid item xs={12}>
                <Stack spacing={1}>
                  <InputLabel htmlFor="confirmpassword-login">Confirm Password</InputLabel>
                  <OutlinedInput
                    fullWidth
                    error={Boolean(touched.confirmpassword && errors.confirmpassword)}
                    id="confirmpassword-login"
                    type={showConfirmPassword ? 'text' : 'password'}
                    value={values.confirmpassword}
                    name="confirmpassword"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowConfirmPassword}
                          onMouseDown={handleMouseDownConfirmPassword}
                          edge="end"
                          size="large"
                        >
                          {showConfirmPassword ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                        </IconButton>
                      </InputAdornment>
                    }
                    placeholder="Enter confirm password"
                  />
                  {touched.confirmpassword && errors.confirmpassword && (
                    <FormHelperText error id="standard-weight-helper-text-password-login">
                      {errors.confirmpassword}
                    </FormHelperText>
                  )}
                </Stack>
              </Grid>
              {errors.submit && (
                <Grid item xs={12}>
                  <FormHelperText error>{errors.submit}</FormHelperText>
                </Grid>
              )}
              <Grid item xs={12}>
                <AnimateButton>
                  <Button disableElevation disabled={isSubmitting} fullWidth size="large" type="submit" variant="contained" color="primary">
                    Change Password
                  </Button>
                </AnimateButton>
                { IsLoginLinkHide===0
                    && (
                        <Link variant="h6" component={RouterLink} to="/login" color="text.primary">
                            Back to Login ?
                        </Link>
                    )
                }

              </Grid>
            </Grid>
            <Snackbar
                open={open}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                autoHideDuration={6000}
                onClose={handleClose}
                message={successMessage}
                action={action}
                ContentProps={{ sx: { borderRadius: 1.5 } }}
            />
          </form>

        )}
      </Formik>
    </>
  );
};

export default AuthChangePassword;
